import React from "react";
import { Logo } from "./Logo";

interface OverlayLoaderProps {
  message?: string;
}

export const OverlayLoader: React.FC<OverlayLoaderProps> = ({ message }) => {
  return (
    <div className="fixed inset-0 z-[60] bg-black bg-opacity-60 flex items-center justify-center">
      <div className="flex flex-col items-center">
        <div className="animate-spin-slow">
          <Logo height={64} width={64} className="" />
        </div>
        {message && <p className="mt-4 text-white text-center">{message}</p>}
      </div>
    </div>
  );
};
